const dateToJST = (date: string) => new Intl.DateTimeFormat('en-GB', { timeZone: 'JST', dateStyle: 'medium', timeStyle: 'long' }).format(new Date(date));

export default dateToJST;
